'use client'

import { useEffect, useState, useRef, FC } from 'react'

import { IProjectReports } from '@/types'

const StepCard: FC<IProjectReports> = ({ header, title, description }) => {
  const divRef = useRef(null)
  const [isInViewport, setIsInViewport] = useState(false)

  useEffect(() => {
    // Function to check if the element is in the viewport
    const isElementInViewport = (el: any) => {
      if (el) {
        const rect = el.getBoundingClientRect()

        return rect.top <= (window.innerHeight / 2 || document.documentElement.clientHeight / 2)
      }
    }

    // Function to handle scrolling and update the state
    const handleScroll = () => {
      if (divRef && isElementInViewport(divRef.current)) {
        setIsInViewport(true)
      } else {
        setIsInViewport(false)
      }
    }

    // An event listener to check if the div is in the viewport when scrolling
    window.addEventListener('scroll', handleScroll)

    // Initial check
    handleScroll()

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div ref={divRef} className="relative flex grid-cols-[1fr_90px_1fr] flex-col md:grid">
      <div className="relative order-2 md:order-1">
        <h1
          className={`mb-4 text-[28px] leading-[130%] duration-200 ${
            !isInViewport ? ' text-secondary' : ' text-secondary-darkest'
          }`}
        >
          {header}
        </h1>
        {title ? (
          <p
            className={`text-[18px] duration-200 ${
              isInViewport ? 'text-secondary-darkest' : 'text-secondary'
            }`}
          >
            {title}
          </p>
        ) : null}
      </div>
      <div className="order-1 flex w-fit translate-x-[-10px] flex-col items-center  gap-2 md:order-2 md:translate-x-0">
        <div
          className={`box-content h-[15px] w-[15px] rounded-full border-[10px] border-white duration-200 ${
            isInViewport ? 'bg-primary' : 'bg-secondary-light'
          }`}
        />
      </div>
      <div
        className={isInViewport ? 'order-3 text-secondary' : 'order-3 [&_p]:text-secondary'}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  )
}

export default StepCard
